import { ReactElement } from 'react';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import Switch from '@src/sld/components/Switch/Switch';

const rectTextProps = {
  fill: 'currentColor',
  stroke: 'none',
  textAnchor: 'right',
  fontSize: '8px',
};

type BreakerStackProps = {
  translateXCoordinate: number;
  translateYCoordinate: number;
  switchLabel: string;
  breakerLabel: string;
};

function BreakerStack(props: BreakerStackProps): ReactElement {
  const {
    translateXCoordinate,
    translateYCoordinate,
    switchLabel,
    breakerLabel,
  } = props;
  const translate = `translate(${translateXCoordinate}, ${translateYCoordinate})`;

  return (
    <g transform={translate}>
      <VerticalLine
        translateXCoordinate={-112.5}
        translateYCoordinate={712}
        length={10}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />
      <Switch
        label={switchLabel}
        isClosed={false}
        translateXCoordinate={-112}
        translateYCoordinate={700}
        stroke='green'
      />

      <rect
        x={-123}
        y='723'
        width='20'
        height='20'
        fill='grey'
        strokeWidth={0.5}
      />
      <text x={-90} y={735} {...rectTextProps}>
        {breakerLabel}
      </text>

      <VerticalLine
        translateXCoordinate={-113.5}
        translateYCoordinate={744}
        length={15}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />
    </g>
  );
}

export default BreakerStack;
